import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { r230522SocketBunja } from './socket';
import { WsV2Events } from './types';

export interface WhalePosition {
  symbol: string;
  side: 'Long' | 'Short';
  positionSize: string;
  entryPrice: string;
  timestamp: string;
}

export type WhalePositions = WhalePosition[];

export interface WhalePositionEvent {
  s: string; // symbol
  d: 'Long' | 'Short'; // side
  p: string; // positionSize
  e: string; // entryPrice
  t: string; //timestamp
}

function updateWhalePositions(prev: WhalePositions, event: WhalePositionEvent): WhalePositions {
  return [
    {
      symbol: event.s,
      side: event.d,
      positionSize: event.p,
      entryPrice: event.e,
      timestamp: event.t,
    },
    ...prev,
  ];
}

const whalePositionsAtom = atom<WhalePositions>([]);

export const whalePositionsBunja = bunja(() => {
  const { r230522Events } = bunja.use(r230522SocketBunja);
  const store = bunja.use(JotaiStoreScope);

  bunja.effect(() => {
    function handler(event: WsV2Events['market/whale-position']) {
      store.set(whalePositionsAtom, (prev) => updateWhalePositions(prev, event));
    }

    r230522Events.on('market/whale-position', handler);
    return () => {
      r230522Events.off('market/whale-position', handler);
    };
  });

  return {
    whalePositionsAtom,
  };
});
whalePositionsBunja.debugLabel = 'whalePositionBunja';
